module.exports = __webpack_public_path__ + "static/media/thumbs-up.9f822ee3.png";